import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const GetSignInTypeContext = React.createContext({});
export let getSignInTypeMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMGetSignInType = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getSignInTypeMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getSignInTypeMachine);

  return {
    getSignInTypeMachine,
    getSignInTypeState: state,
    getSignInTypeSend: send,
  };
};
